<template>
  <div>
    <div
      class="modal"
      :class="{ 'is-visible': isSmsLoginModalVisible }"
      id="sms-login-modal"
      @keyup.esc="isSmsLoginModalVisible = false"
      @click.self="isSmsLoginModalVisible = false"
      tabindex="0"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          Logg inn
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="isSmsLoginModalVisible = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content" v-if="!deliveryPoint.id">
          <p>
            For et riktigere estimat på dekket forbruk og besparelse kan du
            logge inn med mobilnummeret registrert på ditt kundeforhold hos oss
            og la oss hente informasjon om ditt strømforbruk.
          </p>

          <select-place-of-consumption
            v-if="showSelectPlaceOfConsumption"
          ></select-place-of-consumption>
          <template v-else>
            <template v-if="!codeSent">
              <input
                autofocus
                type="text"
                v-model="phoneNumber"
                name="phone"
                autocomplete="tel"
                placeholder="Mobilnummer"
                aria-label="Mobilnummer"
              />
              <p v-if="phoneNumberError" v-text="phoneNumberError"></p>

              <button
                type="button"
                class="btn btn-solid btn-arrow btn-hk-blue-deep"
                @click.prevent="requestCode"
              >
                Motta engangskode
              </button>
            </template>
            <template v-else>
              <input
                autofocus
                type="text"
                v-model="smsCode"
                autocomplete="one-time-code"
                placeholder="Kode fra SMS"
                aria-label="Kode fra SMS"
              />

              <button
                type="button"
                class="btn btn-solid btn-arrow btn-hk-blue-deep"
                @click.prevent="submitCode"
              >
                Logg inn
              </button>
            </template>
          </template>

          <p
            class="text-red-light"
            v-if="errorMessage"
            v-text="errorMessage"
          ></p>
        </section>
        <section class="modal-content" v-else>
          <img
            :src="imagePath + '/img/check.svg'"
            alt="Suksess"
            class="checkmark-icon"
          />
          <p>
            Du er nå logget inn og vil få et riktigere estimat på dekket forbruk
            og besparelse.
          </p>
          <button
            type="button"
            class="btn btn-solid btn-arrow btn-hk-blue-deep"
            @click="isSmsLoginModalVisible = false"
          >
            Fortsett
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import SelectPlaceOfConsumption from './SelectPlaceOfConsumption';

export default {
  name: 'SmsLogin',
  components: {
    SelectPlaceOfConsumption,
  },
  methods: {
    requestCode() {
      store.dispatch('smsLogin/getLoginCode');
    },
    submitCode() {
      store.dispatch('smsLogin/getActors');
    },
  },
  computed: {
    codeSent() {
      return store.state.smsLogin.smsCodeSent;
    },
    actors() {
      return store.state.smsLogin.actors;
    },
    selectedActor() {
      return store.state.smsLogin.selectedActor;
    },
    deliveryPoint() {
      return store.state.smsLogin.deliveryPoint;
    },
    phoneNumber: {
      get() {
        return store.state.CustomerInformation.phoneNumber;
      },
      set(value) {
        store.commit('setPhoneNumber', value);
      },
    },
    smsCode: {
      get() {
        return store.state.smsLogin.smsCode;
      },
      set(value) {
        store.commit('smsLogin/setSmsCode', value);
      },
    },
    errorMessage() {
      return store.state.smsLogin.errorMessage;
    },
    phoneValid() {
      return this.phoneNumber.length > 7;
    },
    phoneNumberError() {
      var re = /^\d{8}$/;
      if (this.phoneNumber && !this.phoneValid) {
        return 'Vennligst skriv inn et gyldig telefonnummer';
      }
      if (this.phoneNumber && !re.test(this.phoneNumber)) {
        return 'Telefonnummer skal inneholde 8 tegn og kun tall.';
      }
      return false;
    },
    showSelectPlaceOfConsumption() {
      return this.actors && !this.deliveryPoint.id;
    },
    imagePath() {
      return store.state.imagePath;
    },
    isSmsLoginModalVisible: {
      get() {
        return store.state.smsLogin.isSmsLoginModalVisible;
      },
      set(value) {
        store.commit('smsLogin/setSmsLoginModalVisibility', value);
      },
    },
  },
};
</script>

<style scoped>
.checkmark-icon {
  display: block;
  width: 100px;
  margin: 0 auto;
}
</style>
